import { z } from "zod";
import { useValidation } from "../../hooks/use-validation";
import { ReactNode } from "react";

export const Form = <T extends { [P in keyof T]: P extends string ? T[P] : never }, K extends z.ZodTypeAny>({
	formData,
	fields,
	validationSchema,
	children,
	zIndex,
}: {
	formData: T;
	fields?: (keyof T)[];
	validationSchema?: K;
	children: (props: {
		onValidate: () => boolean;
		errors: z.inferFlattenedErrors<z.ZodTypeAny> | undefined;
		fields: (keyof T)[];
	}) => ReactNode;
	zIndex?: number;
}) => {
	const [errors, onValidate] = useValidation(validationSchema ? validationSchema : z.looseObject({}));
	const fieldsToDisplay = fields
		? (Object.keys(formData ?? {}).filter((key) => fields.includes(key as keyof T)) as (keyof T)[])
		: (Object.keys(formData ?? {}) as (keyof T)[]);

	const onInternalValidate = () => {
		const err = onValidate(formData);
		return err;
	};

	return (
		<form noValidate style={{ zIndex: zIndex ?? "auto" }}>
			{children({ onValidate: onInternalValidate, errors: errors, fields: fieldsToDisplay })}
		</form>
	);
};
